type Cell = string | number | null | undefined

export const downloadXlsx = async (filename: string, header: string[], rows: Cell[][], sheet = 'Report') => {
  const XLSX = await import('xlsx')
  const worksheet = XLSX.utils.aoa_to_sheet([header, ...rows.map((r) => r.map((v) => (v == null ? '' : v)))])
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, sheet.replace(/[[\]:*?/\\]/g, ' ').slice(0, 31))
  XLSX.writeFile(workbook, filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`)
}
